import { useEffect } from 'react';
import { Action, CollectionServer, ContextFiltersToQueryFilters, deleteInArray, DropdownAction, errorCatch, Field, GET, GETWITH, JSXMap, makeFormData, Model, POST, POSTFormData, queryFilterByItem, QueryParam, QueryParams, updateInArray, useAuth, useFormObserverContext } from 'fennec-ui';

import MDEditor, { commands, EditorContext } from "@uiw/react-md-editor";
import rehypeSanitize from "rehype-sanitize";
import rehypeTruncate from "rehype-truncate"
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useState } from 'react';
import { useCallback } from 'react';
import { Collapse, Tooltip } from 'antd';
import { Input } from 'antd';
import Icofont from 'react-icofont';
import { Spin } from 'antd';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { getIndexColorLighter } from '../../../common/Tool';
import "./index.less"
import FormItem from 'antd/es/form/FormItem';
import EmojiTextArea from '../../../common/EmojiTextArea';
dayjs.locale('ru');

var _ = require('lodash');

// "/api/dopolnitelniepolyaobekta/get" ?tantsorID=12 & w-eq-key=123
// "/api/dopolnitelniepolyaobekta/set" POST
// "/api/dopolnitelniepolyaobekta/delete/{id}"

// DopolnitelniePolyaObekta

// "tantsorID" tipPolzovatelyaID=16
// "tantsor"
// "prepodavatelID" tipPolzovatelyaID=21
// "prepodavatel"
// "sudyaID" tipPolzovatelyaID=22
// "sudya"
// "regionalnoeOtdelenieID" 
// "regionalnoeOtdelenie"
// "shkolaID" tipPolzovatelyaID=18
// "shkola"
// "organizatorID" tipPolzovatelyaID=23
// "organizator"
// "paraID" tipPolzovatelyaID=17
// "para"
// "kollektivID" tipPolzovatelyaID=20
// "kollektiv"
// "meropriyatieID"
// "meropriyatie"
// "seriyaID"
// "seriya"
// "festivalID"
// "festival"
// "polzovatelID"
// "polzovatel"
// "chlenFederatsiiID" tipPolzovatelyaID=10
// "chlenFederatsii"
// "tipPolzovatelyaID"
// "tipPolzovatelya"
// "key"
// "value"
// "aktualnoS"
// "aktualnoDo"


export const PropertyField = (props) => {
    const auth = useAuth();
    const { value: initialValue, onChange, item, style, disabled: initialDisabled, colorClass } = props;
    const [value, setValue] = useState(initialValue);
    const [disabled, setDisabled] = useState(initialDisabled);
    const [lastError, setLastError] = useState();
    const lock = () => { setDisabled(true) }
    const unlock = () => { setDisabled(false) }

    const isEqual = (a, b) => (a?.value != b?.value ||
        a?.aktualnoS != b?.aktualnoS ||
        a?.aktualnoDo != b?.aktualnoDo
    )
    const onError = useCallback((e) => {
        if (isEqual(initialValue, value)) {
            setLastError(e);
        }
    }, [initialValue, value]);
    const onEnter = useCallback(() => {
        if (onChange) {
            onChange(value, onError, lock, unlock);
        }
    }, [value]);
    const onBlur = useCallback(() => {
        if (isEqual(initialValue, value)) {
            if (onChange) {
                onChange(value, onError, lock, unlock);
            }
        }
    }, [initialValue, value]);
    const onClear = useCallback(() => {
        if (onChange) {
            onChange(undefined, onError, lock, unlock)
        }
    }, []);

    useEffect(() => {
        setLastError(undefined);
    }, [value]);
    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);
    useEffect(() => {
        setDisabled(initialDisabled);
    }, [initialDisabled]);
    const stateClassValue = useCallback(() => {
        if (initialValue?.value != value?.value) {
            if (lastError) {
                return "error";
            }
            return "warning";
        }
        return ""
    }, [initialValue, value, lastError]);
    const stateClassAktualnoS = useCallback(() => {
        if (initialValue?.aktualnoS != value?.aktualnoS) {
            if (lastError) {
                return "error";
            }
            return "warning";
        }
        return ""
    }, [initialValue, value, lastError]);
    const stateClassAktualnoDo = useCallback(() => {
        if (initialValue?.aktualnoDo != value?.aktualnoDo) {
            if (lastError) {
                return "error";
            }
            return "warning";
        }
        return ""
    }, [initialValue, value, lastError]);
    return (
        <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", ...style }} onClick={(e) => { e.preventDefault() }}>
            <div style={{ height: "100%", position: "relative", width: "100%", display: "flex", flexDirection: "column", gap: "3px" }}>
                {!item?.propfields?.hideValue && <Field
                    auth={auth}
                    item={{
                        ...item,
                        view: {
                            disabled: disabled,
                        }
                    }}
                    value={value?.value}
                    onChange={v => {
                        if (v !== undefined) {
                            setValue({
                                ...value,
                                value: v,
                            })
                        }
                    }}
                    // wrapperProps={{
                    //     className: "gradient-border"
                    // }}
                    inputProps={{
                        // allowClear: true,
                        // rows: 4,
                        className: `${stateClassValue()}`,
                        onBlur: onBlur,
                        // onPressEnter: onEnter,
                        // onClear: onClear,
                    }}
                />}
                <div style={{ display: "flex", justifyContent: "right", gap: "3px" }}>
                    {item?.propfields?.showAktualnoS && <div>
                        <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>Год начала</div>
                        <Field
                            auth={auth}
                            item={{
                                label: "",
                                name: item?.name,
                                type: "date",
                                view: {
                                    disabled: disabled,
                                },
                                fieldLayoutStyle: {
                                    width: "auto"
                                }
                            }}
                            value={value?.aktualnoS}
                            onChange={v => {
                                if (onChange) {
                                    onChange({
                                        ...value,
                                        aktualnoS: v,
                                    }, onError, lock, unlock);
                                }
                            }}
                            // wrapperProps={{
                            //     className: "gradient-border"
                            // }}
                            inputProps={{
                                needConfirm: true,
                                className: `${stateClassAktualnoS()}`,
                                picker: "year",
                                format: "YYYY",
                                size: "small",
                                // variant: "borderless",
                                variant: "filled",
                                // variant: "underlined",
                                // placeholder: "Выберите год",
                            }}
                        />
                    </div>}
                    {item?.propfields?.showAktualnoDo && <div>
                        <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>Год окончания</div>
                        <Field
                            auth={auth}
                            item={{
                                label: "",
                                name: item?.name,
                                type: "date",
                                view: {
                                    disabled: disabled,
                                },
                                fieldLayoutStyle: {
                                    width: "auto"
                                }
                            }}
                            value={value?.aktualnoDo}
                            onChange={v => {
                                if (onChange) {
                                    onChange({
                                        ...value,
                                        aktualnoDo: v,
                                    }, onError, lock, unlock);
                                }
                            }}
                            // wrapperProps={{
                            //     className: "gradient-border"
                            // }}
                            inputProps={{
                                needConfirm: true,
                                className: `${stateClassAktualnoDo()}`,
                                picker: "year",
                                format: "YYYY",
                                size: "small",
                                // variant: "borderless",
                                variant: "filled",
                                // variant: "underlined",
                                // placeholder: "Год окончания",
                            }}
                        />
                    </div>}
                </div>
                {lastError && <div style={{
                    position: "absolute",
                    top: "2px",
                    right: "3px",
                    fontSize: "14px"
                }}>
                    {<Tooltip title={(lastError && lastError.message) ? lastError.message : ""}><Icofont icon="exclamation" style={{ color: "red" }} /></Tooltip>}
                </div>}
            </div>
        </div>
    )
};

export const ArrayField = (props) => {
    const auth = useAuth();
    const { value, onChange, item, style, disabled: initialDisabled, colorClass } = props;
    const [disabled, setDisabled] = useState(initialDisabled);
    const [lastError, setLastError] = useState();
    const lock = () => { setDisabled(true) }
    const unlock = () => { setDisabled(false) }

    const onError = useCallback((e) => {
        setLastError(e);
    }, [value]);
    useEffect(() => {
        setLastError(undefined);
    }, [value]);
    useEffect(() => {
        setDisabled(initialDisabled);
    }, [initialDisabled]);
    return (
        <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", ...style }} onClick={(e) => { e.preventDefault() }}>
            <div style={{ height: "100%", position: "relative", width: "100%", display: "flex", flexDirection: "column", gap: "3px" }}>
                {!item?.propfields?.hideValue && <Field
                    auth={auth}
                    item={{
                        ...item,
                        view: {
                            disabled: disabled,
                        }
                    }}
                    value={value}
                    onChange={v => {
                        if (onChange) {
                            onChange(v, onError, lock, unlock);
                            // onChange({
                            //     ID: v?.ID,
                            //     opisanie: v?.opisanie,
                            //     file: v?.file,
                            //     value: v?.value,
                            //     aktualnoS: v?.aktualnoS,
                            //     aktualnoDo: v?.aktualnoDo,
                            // }, onError, lock, unlock);
                        }
                    }}
                    // wrapperProps={{
                    //     className: "gradient-border"
                    // }}
                    inputProps={{
                        // allowClear: true,
                        // rows: 4,
                        // className: `${stateClassValue()}`,
                        // onBlur: onBlur,
                        // onPressEnter: onEnter,
                        // onClear: onClear,
                    }}
                />}
                {lastError && <div style={{
                    position: "absolute",
                    top: "2px",
                    right: "3px",
                    fontSize: "14px"
                }}>
                    {<Tooltip title={(lastError && lastError.message) ? lastError.message : ""}><Icofont icon="exclamation" style={{ color: "red" }} /></Tooltip>}
                </div>}
            </div>
        </div>
    )
};

// POST "/api/dopolnitelniepolyaobekta/set-for-president/{userID}"
// GET "/api/dopolnitelniepolyaobekta/deletefield-for-president/{poleID}/{userID}"
// GET "/api/dopolnitelniepolyaobekta/deletevalue-for-president/{znachenieID}/{userID}"
// POST "/api/moitantsi/new-for-president/{userID}"
// POST "/api/moitantsi/update-for-president/{userID}"
// GET "/api/moitantsi/delete-for-president/{id}/{userID}"
// GET "/api/moitantsi/get-for-president/{id}/{userID}"
// GET "/api/moitantsi/list-for-president/{userID}


export function ExtendedPropertiesForPresident(props) {
    const { auth, object, form, ContextObject, Fields, dances, userID } = props;
    const ContextFilter = useCallback(() => [
        // QueryParam("w-eq-key", "123"),
    ], []);

    const [propertiesArray, setPropertiesArray] = useState();

    const request = useCallback(() => {
        GETWITH(auth, '/api/dopolnitelniepolyaobekta/get', [
            ...Object.keys(ContextObject)?.map((item) => {
                var keyName = (!!item.endsWith('ID') && !item.endsWith('.ID')) ? item.slice(0, -2) + ".ID" : item;
                if (ContextObject?.[item]) {
                    return QueryParam("w-"+keyName, ContextObject?.[item])
                } else {
                    return QueryParam("w-nu-"+keyName, true)
                }
            }),
            ...ContextFiltersToQueryFilters(ContextFilter)
        ], ({ data }) => {
            setPropertiesArray(data);
        }, (err) => errorCatch(err));

        // GETWITH(auth, '/api/dopolnitelniepolyaobekta/get', [
        //     ...Object.keys(ContextObject)?.map((item) => QueryParam(item, ContextObject?.[item])),
        //     ...ContextFiltersToQueryFilters(ContextFilter)
        // ], ({ data }) => {
        //     setPropertiesArray(data);
        // }, (err) => errorCatch(err));
    }, [ContextObject])

    useEffect(() => {
        if (form) {
            form?.resetFields();
        }
        request()
    }, []);

    const EmojiField = useCallback((auth, item, value, onChange, onAfterChange) => {
        return (<EmojiTextArea
            rows={8}
            auth={auth}
            // item={item}
            value={value}
            onChange={onChange}
            onAfterChange={onAfterChange}
        />)
    }, [auth])

    return (
        <div className="border-fwhite" style={{ padding: "5px 10px", marginBottom: "5px" }}>
            {dances && <div className='my-dances-field' style={{ marginBottom: "6px" }}>
                <CollectionServer
                    auth={auth}
                    name={"MoiTantsi"}
                    source={`/api/moitantsi/list-for-president/${userID}`}
                    // contextFilters={FilterFromContextFilter}
                    // filters={filters}
                    filters={() => []}
                    size={"small"}
                    // mode={"list"}
                    queryDetail={"model"}
                    customRender={(items, {
                        collection,
                        setCollection,
                        setCollectionItem,
                        removeCollectionItem,
                        collectionActions,
                        modelActions,
                        update,
                        loading,
                        response
                    }) => {
                        return (<div key="items" style={{ paddingTop: "5px" }}>
                            <Spin spinning={loading}>
                                <div style={{ /*height: "200px", overflowY: "auto",*/ border: "1px solid #ededed", borderRadius: "4px" }}>
                                    <Collapse
                                        ghost
                                        // accordion
                                        items={_.uniqBy(items?.map(x => ({
                                            vidDeyatelnostiID: x.vidDeyatelnostiID,
                                            vidDeyatelnosti: x.vidDeyatelnosti
                                        })), (x) => x.vidDeyatelnostiID)?.map((item, idx) => {
                                            return ({
                                                key: idx,
                                                className: `protocols-collapse-item`,
                                                label: (<div className={`bg bg-fwhite`} style={{ backgroundColor: getIndexColorLighter(item.vidDeyatelnostiID, 0.1), textAlign: "left", fontWeight: "bold", padding: "0px 5px", display: "flex" }}>
                                                    <div style={{ flex: "0 0 auto" }}>{`${item.vidDeyatelnosti?.nazvanie}`}</div>
                                                </div>),
                                                children: (<div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                                    {JSXMap(items?.filter(e => e.vidDeyatelnostiID == item?.vidDeyatelnostiID),
                                                        (dance, didx) => (<div key={didx} className='bg bg-fwhite pointer'
                                                            style={{
                                                                display: "flex",
                                                                gap: "5px",
                                                                textAlign: "left",
                                                                padding: "0 5px",
                                                                marginLeft: "5px"
                                                            }}>
                                                            <div style={{ flex: "1 1 auto" }}>
                                                                <div style={{ fontWeight: "bold" }}>
                                                                    <div>{dance?.tanets?.nazvanie}</div>
                                                                    {(dance?.tanets?.nazvanie !== dance?.tanets?.opisanie) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>{dance?.tanets?.opisanie}</div>}
                                                                </div>
                                                                <div style={{ display: "flex", gap: "5px", fontSize: "12px", fontWeight: "lighter" }}>
                                                                    {dance?.nachalo && <div>
                                                                        <span>с</span>
                                                                        <span style={{ marginLeft: "3px" }}>{dayjs(dance?.nachalo).format("YYYY")}</span>
                                                                        <span style={{ marginLeft: "1px" }}>г.</span>
                                                                    </div>}
                                                                    {dance?.okonchanie && <div>
                                                                        <span>до</span>
                                                                        <span style={{ marginLeft: "3px" }}>{dayjs(dance?.okonchanie).format("YYYY")}</span>
                                                                        <span style={{ marginLeft: "1px" }}>г.</span>
                                                                    </div>}
                                                                    {(dance?.nachalo && !dance?.okonchanie) && <div>
                                                                        <span>по настоящее время</span>
                                                                    </div>}
                                                                    <div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {(modelActions(dance, idx)?.length) && <div style={{ flex: "0 0 25px" }}>
                                                                <DropdownAction
                                                                    style={{ padding: "0" }}
                                                                    button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                                        <i className="fa fa-ellipsis-h"></i>
                                                                    </div>)}
                                                                    items={modelActions(dance, idx)?.map((e, idx) => ({
                                                                        key: e.key || idx,
                                                                        auth: auth,
                                                                        mode: "MenuItem",
                                                                        object: dance,
                                                                        collection: collection,
                                                                        setCollection: setCollection,
                                                                        ...e
                                                                    }))} />
                                                            </div>}
                                                        </div>))}
                                                </div>),
                                            })
                                        })}
                                    />
                                </div>
                            </Spin>
                        </div>)
                    }}
                    collectionActions={() => [
                        {
                            action: (values, unlock, close, { collection, setCollection }) => {
                                POST(auth, `/api/moitantsi/new-for-president/${userID}`, values,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    },
                                    (err) => errorCatch(err, unlock));
                            },
                            form: Model,
                            meta: [
                                {
                                    "name": "VidDeyatelnosti",
                                    "type": "object",
                                    "label": "Вид деятельности",
                                    "relation": {
                                        "type": "many-one",
                                        "reference": {
                                            "object": "VidDeyatelnosti",
                                            "property": "ID"
                                        },
                                        displayString: (item) => {
                                            return item?.nazvanie
                                        },
                                        display: (item) => {
                                            return (
                                                item?.nazvanie
                                            )
                                        },
                                    },
                                    "validators": {
                                        "required": true,
                                    },
                                },
                                {
                                    "name": "Tanets",
                                    "type": "object",
                                    "label": "Танец",
                                    "relation": {
                                        "type": "many-one",
                                        "reference": {
                                            "object": "Tantsi",
                                            "property": "ID"
                                        },
                                        displayString: (item) => {
                                            return item?.nazvanie + ((item?.nazvanie !== item?.opisanie) ? " (" + item?.opisanie + ")" : "")
                                        },
                                        display: (item) => {
                                            return (
                                                <div>
                                                    <div>{item?.nazvanie}</div>
                                                    {(item?.nazvanie !== item?.opisanie) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>{item?.opisanie}</div>}
                                                </div>
                                            )
                                        },
                                    },
                                    "validators": {
                                        "required": true,
                                    },
                                },
                                {
                                    "name": "Nachalo",
                                    "type": "date",
                                    "label": "Начало",
                                    "validators": {
                                        "required": false,
                                    },
                                    inputProps: {
                                        needConfirm: true,
                                        picker: "year",
                                        format: "YYYY",
                                    }
                                },
                                {
                                    "name": "Okonchanie",
                                    "type": "date",
                                    "label": "Окончание",
                                    "validators": {
                                        "required": false,
                                    },
                                    inputProps: {
                                        needConfirm: true,
                                        picker: "year",
                                        format: "YYYY",
                                    }
                                },
                            ],
                            options: {
                                initialValues: {},
                            },
                            title: "Добавить танец",
                            modal: {
                                width: "400px",
                                title: "Новый танец",
                            }
                        }
                    ]}
                    modelActions={(item) => [{
                        auth: auth,
                        title: "Изменить",
                        modal: {
                            width: "400px",
                            title: "Изменить параметры танца",
                        },
                        object: item,
                        action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/moitantsi/update-for-president/${userID}`, { ...item, ...values, ID: item.ID },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                close();
                            },
                            (err) => errorCatch(err, unlock)),
                        form: Model,
                        meta: [
                            // {
                            //     type: "func",
                            //     render: (auth, _item) => {
                            //         return (<div>
                            //             <div>{item?.tantsevalnayaDistsiplina?.nazvanie}</div>
                            //             <div><User item={item?.polzovatel} /></div>
                            //         </div>)
                            //     }
                            // },
                            {
                                "name": "VidDeyatelnosti",
                                "type": "object",
                                "label": "Вид деятельности",
                                "relation": {
                                    "type": "many-one",
                                    "reference": {
                                        "object": "VidDeyatelnosti",
                                        "property": "ID"
                                    },
                                    displayString: (item) => {
                                        return item?.nazvanie
                                    },
                                    display: (item) => {
                                        return (
                                            item?.nazvanie
                                        )
                                    },
                                },
                                "validators": {
                                    "required": true,
                                },
                                view: {
                                    disabled: true
                                }
                            },
                            {
                                "name": "Tanets",
                                "type": "object",
                                "label": "Танец",
                                "relation": {
                                    "type": "many-one",
                                    "reference": {
                                        "object": "Tantsi",
                                        "property": "ID"
                                    },
                                    displayString: (item) => {
                                        return item?.nazvanie + ((item?.nazvanie !== item?.opisanie) ? " (" + item?.opisanie + ")" : "")
                                    },
                                    display: (item) => {
                                        return (
                                            <div>
                                                <div>{item?.nazvanie}</div>
                                                {(item?.nazvanie !== item?.opisanie) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>{item?.opisanie}</div>}
                                            </div>
                                        )
                                    },
                                },
                                "validators": {
                                    "required": true,
                                },
                            },
                            {
                                "name": "Nachalo",
                                "type": "date",
                                "label": "Начало",
                                "validators": {
                                    "required": false,
                                },
                                inputProps: {
                                    needConfirm: true,
                                    picker: "year",
                                    format: "YYYY",
                                }
                            },
                            {
                                "name": "Okonchanie",
                                "type": "date",
                                "label": "Окончание",
                                "validators": {
                                    "required": false,
                                },
                                inputProps: {
                                    needConfirm: true,
                                    picker: "year",
                                    format: "YYYY",
                                }
                            },
                        ],
                    },
                    {
                        title: <span style={{ color: "red" }}>Удалить</span>,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            Modal.confirm({
                                title: `Вы уверены что хотите удалить танец?`,
                                icon: <ExclamationCircleOutlined />,
                                // content: <span>{item.opisanie}</span>,
                                okText: "Да",
                                okType: 'danger',
                                cancelText: "Нет",
                                onOk: () => {
                                    GET(auth, `/api/moitantsi/delete-for-president/${item.ID}/${userID}`,
                                        () => {
                                            setCollection(deleteInArray(collection, item))
                                        }, errorCatch
                                    );
                                },
                            });
                        },
                    }
                    ]}
                />
            </div>}
            {
                JSXMap(Fields, (item, index) => {
                    const element = propertiesArray?.find(i => i.key == item.name);
                    const elementValues = _.head(element?.kollektsiiZnacheniiPoleiObekta)
                    const elementMD = propertiesArray?.find(i => i.key == (item.name + "_MD"));
                    const elementValuesMD = _.head(elementMD?.kollektsiiZnacheniiPoleiObekta)
                    return (
                        <div key={index} style={{ marginBottom: "6px" }}>
                            {(!!item?.array) && <ArrayField
                                item={item}
                                value={element?.kollektsiiZnacheniiPoleiObekta}
                                onChange={(val, onError, lock, unlock) => {
                                    if (lock) {
                                        lock()
                                    }
                                    if (!val && element) {
                                        GET(auth, `/api/dopolnitelniepolyaobekta/deletefield-for-president/${element?.ID}/${userID}`,
                                            ({ data }) => {
                                                setPropertiesArray(o => deleteInArray(o, element))
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }, (err) => errorCatch(err, () => {
                                                onError(err);
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }))
                                        return
                                    }
                                    if (val && !val?.value && !val?.file && element) {
                                        GET(auth, `/api/dopolnitelniepolyaobekta/deletevalue-for-president/${val?.ID}/${userID}`,
                                            ({ data }) => {
                                                setPropertiesArray(o => updateInArray(o, {
                                                    ...element,
                                                    kollektsiiZnacheniiPoleiObekta: deleteInArray(element.kollektsiiZnacheniiPoleiObekta, val)
                                                }))
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }, (err) => errorCatch(err, () => {
                                                onError(err);
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }))
                                        return
                                    }

                                    POSTFormData(auth, `/api/dopolnitelniepolyaobekta/set-for-president/${userID}`, makeFormData({
                                        ...ContextObject,
                                        ...element,
                                        key: item.name,

                                        valueID: val?.ID,
                                        opisanie: val?.opisanie,
                                        file: val?.file,
                                        value: val?.value,
                                        aktualnoS: val?.aktualnoS,
                                        aktualnoDo: val?.aktualnoDo,

                                        kollektsiiZnacheniiPoleiObekta: undefined,

                                    }), ({ data }) => {
                                        setPropertiesArray(o => updateInArray(o, data))
                                        if (unlock) {
                                            unlock()
                                        }
                                    }, (err) => errorCatch(err, () => {
                                        onError(err);
                                        if (unlock) {
                                            unlock()
                                        }
                                    }))
                                }}
                            />}
                            {(!item?.array) && <div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div style={{ fontWeight: "bold", flex: "1 1 auto" }}>{item?.label}</div>
                                    <div style={{ flex: "0 0 30px", textAlign: "right" }}><i className="fa fa-pencil-square-o"></i></div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <Action
                                        auth={auth}
                                        action={(values, unlock, close, { collection, setCollection }) => {
                                            if (!values?.value && element) {
                                                GET(auth, `/api/dopolnitelniepolyaobekta/deletefield-for-president/${element?.ID}/${userID}`,
                                                    ({ data }) => {
                                                        setPropertiesArray(o => deleteInArray(o, element))
                                                        if (unlock) {
                                                            unlock()
                                                        }
                                                        close();
                                                    }, (err) => errorCatch(err, () => {
                                                        if (unlock) {
                                                            unlock()
                                                        }
                                                    }))
                                                return
                                            }
                                            POSTFormData(auth, `/api/dopolnitelniepolyaobekta/set-for-president/${userID}`, makeFormData({
                                                ...ContextObject,
                                                ...element,
                                                key: item.name,

                                                valueID: elementValues?.ID,
                                                active: values?.active,
                                                opisanie: values?.opisanie,
                                                value: values?.value,
                                                aktualnoS: (values?.aktualnoS) ? dayjs(values?.aktualnoS)?.format("YYYY-MM-DD") : undefined,
                                                aktualnoDo: (values?.aktualnoDo) ? dayjs(values?.aktualnoDo)?.format("YYYY-MM-DD") : undefined,

                                                kollektsiiZnacheniiPoleiObekta: undefined,

                                            }), ({ data }) => {
                                                setPropertiesArray(o => updateInArray(o, data))
                                                if (unlock) {
                                                    unlock()
                                                }
                                                close();
                                            }, (err) => errorCatch(err, () => {
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }))
                                        }}
                                        object={{
                                            value: (item?.array) ? element?.kollektsiiZnacheniiPoleiObekta : elementValues?.value,
                                            active: elementValues?.active,
                                            aktualnoDo: elementValues?.aktualnoDo,
                                            aktualnoS: elementValues?.aktualnoS,
                                            opisanie: elementValues?.opisanie,
                                            pole: elementValues?.pole,
                                            poleID: elementValues?.poleID,
                                        }}
                                        triggerOptions={{
                                            type: "primary"
                                        }}
                                        form={Model}
                                        meta={[
                                            {
                                                "name": "active",
                                                "type": "bool",
                                                "label": "Активно",
                                            },
                                            {
                                                ...item,
                                                name: "value",
                                                formItem: true,
                                                type: "func",
                                                render: EmojiField,
                                            },
                                            // {
                                            //     "name": "opisanie",
                                            //     "type": "text",
                                            //     "label": "Описание",
                                            //     "validators": {
                                            //         "required": false,
                                            //     }
                                            // },
                                            {
                                                "name": "aktualnoS",
                                                "type": "date",
                                                "label": "Актуально c",
                                                "validators": {
                                                    "required": false,
                                                }
                                            },
                                            {
                                                "name": "aktualnoDo",
                                                "type": "date",
                                                "label": "Актуально до",
                                                "validators": {
                                                    "required": false,
                                                }
                                            },
                                        ]}
                                        options={{
                                            initialValues: {

                                            },
                                        }}
                                        modal={{
                                            width: "900px",
                                            title: "Установка значения",
                                        }}

                                        mode="func"
                                        trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ padding: "5px", textAlign: "start", flex: "1 1 50%" }} >
                                            <div style={{ fontWeight: "bold", fontStyle: "italic", fontSize: "12px", }}>Текст для ВК</div>
                                            <div className="ext-properties" style={{ paddingTop: "5px", fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                                {elementValues?.value?.slice(0, 200)}
                                            </div>
                                        </div>)} />
                                    <Action
                                        auth={auth}
                                        action={(values, unlock, close, { collection, setCollection }) => {
                                            if (!values?.value && elementMD) {
                                                GET(auth, `/api/dopolnitelniepolyaobekta/deletefield-for-president/${elementMD?.ID}/${userID}`,
                                                    ({ data }) => {
                                                        setPropertiesArray(o => deleteInArray(o, elementMD))
                                                        if (unlock) {
                                                            unlock()
                                                        }
                                                        close();
                                                    }, (err) => errorCatch(err, () => {
                                                        if (unlock) {
                                                            unlock()
                                                        }
                                                    }))
                                                return
                                            }
                                            POSTFormData(auth, `/api/dopolnitelniepolyaobekta/set-for-president/${userID}`, makeFormData({
                                                ...ContextObject,
                                                ...elementMD,
                                                key: item.name + "_MD",

                                                valueID: elementValuesMD?.ID,
                                                active: values?.active,
                                                opisanie: values?.opisanie,
                                                value: values?.value,
                                                aktualnoS: (values?.aktualnoS) ? dayjs(values?.aktualnoS)?.format("YYYY-MM-DD") : undefined,
                                                aktualnoDo: (values?.aktualnoDo) ? dayjs(values?.aktualnoDo)?.format("YYYY-MM-DD") : undefined,

                                                kollektsiiZnacheniiPoleiObekta: undefined,

                                            }), ({ data }) => {
                                                setPropertiesArray(o => updateInArray(o, data))
                                                if (unlock) {
                                                    unlock()
                                                }
                                                close();
                                            }, (err) => errorCatch(err, () => {
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }))
                                        }}
                                        object={{
                                            value: (item?.array) ? elementMD?.kollektsiiZnacheniiPoleiObekta : elementValuesMD?.value,
                                            active: elementValuesMD?.active,
                                            aktualnoDo: elementValuesMD?.aktualnoDo,
                                            aktualnoS: elementValuesMD?.aktualnoS,
                                            opisanie: elementValuesMD?.opisanie,
                                            pole: elementValuesMD?.pole,
                                            poleID: elementValuesMD?.poleID,
                                        }}
                                        triggerOptions={{
                                            type: "primary"
                                        }}
                                        form={Model}
                                        meta={[
                                            {
                                                "name": "active",
                                                "type": "bool",
                                                "label": "Активно",
                                            },
                                            {
                                                ...item,
                                                name: "value",
                                                formItem: true,
                                            },
                                            // {
                                            //     "name": "opisanie",
                                            //     "type": "text",
                                            //     "label": "Описание",
                                            //     "validators": {
                                            //         "required": false,
                                            //     }
                                            // },
                                            {
                                                "name": "aktualnoS",
                                                "type": "date",
                                                "label": "Актуально c",
                                                "validators": {
                                                    "required": false,
                                                }
                                            },
                                            {
                                                "name": "aktualnoDo",
                                                "type": "date",
                                                "label": "Актуально до",
                                                "validators": {
                                                    "required": false,
                                                }
                                            },
                                        ]}
                                        options={{
                                            initialValues: {

                                            },
                                        }}
                                        modal={{
                                            width: "900px",
                                            title: "Установка значения",
                                        }}

                                        mode="func"
                                        trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ padding: "5px", textAlign: "start", flex: "1 1 50%" }} >
                                            <div style={{ fontWeight: "bold", fontStyle: "italic", fontSize: "12px", }}>Текст страниц (Markdown)</div>
                                            <div className="ext-properties" style={{ paddingTop: "5px", fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                                <MDEditor.Markdown rehypePlugins={[[rehypeSanitize], [rehypeTruncate, { maxChars: 200 }]]} source={elementValuesMD?.value} />
                                            </div>
                                        </div>)} />
                                </div>
                            </div>}
                        </div>
                    )
                })
            }
        </div>
    );
}


export function ExtendedPropertiesActionForPresident(userID, auth, subtitle, ContextObject, Fields, mode, dances) {
    return {
        // ...props,
        mode: mode,
        title: (<div>
            <div style={{}}>Установка дополнительных параметров</div>
        </div>),
        auth: auth,
        object: {},
        ContextObject: ContextObject,
        Fields: Fields,
        action: (values, unlock, close) => close(),
        form: ExtendedPropertiesForPresident,
        readonly: true,
        noAntForm: true,
        dances: dances,
        userID: userID,
        modal: {
            width: "800px",
            title: (<div>
                <div>Установка дополнительных параметров</div>
                {JSXMap(subtitle, (sbt, idx) => (
                    <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>{sbt}</div>
                ))}
            </div>),
        }
    }
}

// "/api/dopolnitelniepolyaobekta/get"
// "/api/dopolnitelniepolyaobekta/set"
// "/api/dopolnitelniepolyaobekta/deletefield/{poleID}"
// "/api/dopolnitelniepolyaobekta/deletevalue/{znachenieID}"


export default function ExtendedProperties(props) {
    const { auth, object, form, ContextObject, Fields, dances } = props;
    const ContextFilter = useCallback(() => [
        // QueryParam("w-eq-key", "123"),
    ], []);

    const [propertiesArray, setPropertiesArray] = useState();

    const request = useCallback(() => {
        GETWITH(auth, '/api/dopolnitelniepolyaobekta/get', [
            ...Object.keys(ContextObject)?.map((item) => {
                var keyName = (!!item.endsWith('ID') && !item.endsWith('.ID')) ? item.slice(0, -2) + ".ID" : item;
                if (ContextObject?.[item]) {
                    return QueryParam("w-"+keyName, ContextObject?.[item])
                } else {
                    return QueryParam("w-nu-"+keyName, true)
                }
            }),
            ...ContextFiltersToQueryFilters(ContextFilter)
        ], ({ data }) => {
            setPropertiesArray(data);
        }, (err) => errorCatch(err));
    }, [ContextObject])

    useEffect(() => {
        if (form) {
            form?.resetFields();
        }
        request()
    }, []);

    const EmojiField = useCallback((auth, item, value, onChange, onAfterChange) => {
        return (<EmojiTextArea
            rows={8}
            auth={auth}
            // item={item}
            value={value}
            onChange={onChange}
            onAfterChange={onAfterChange}
        />)
    }, [auth])

    return (
        <div className="border-fwhite" style={{ padding: "5px 10px", marginBottom: "5px" }}>
            {dances && <div className='my-dances-field' style={{ marginBottom: "6px" }}>
                <CollectionServer
                    auth={auth}
                    name={"MoiTantsi"}
                    source={`/api/moitantsi/list`}
                    // contextFilters={FilterFromContextFilter}
                    // filters={filters}
                    filters={() => []}
                    size={"small"}
                    // mode={"list"}
                    queryDetail={"model"}
                    customRender={(items, {
                        collection,
                        setCollection,
                        setCollectionItem,
                        removeCollectionItem,
                        collectionActions,
                        modelActions,
                        update,
                        loading,
                        response
                    }) => {
                        return (<div key="items" style={{ paddingTop: "5px" }}>
                            <Spin spinning={loading}>
                                <div style={{ /*height: "200px", overflowY: "auto",*/ border: "1px solid #ededed", borderRadius: "4px" }}>
                                    <Collapse
                                        ghost
                                        // accordion
                                        items={_.uniqBy(items?.map(x => ({
                                            vidDeyatelnostiID: x.vidDeyatelnostiID,
                                            vidDeyatelnosti: x.vidDeyatelnosti
                                        })), (x) => x.vidDeyatelnostiID)?.map((item, idx) => {
                                            return ({
                                                key: idx,
                                                className: `protocols-collapse-item`,
                                                label: (<div className={`bg bg-fwhite`} style={{ backgroundColor: getIndexColorLighter(item.vidDeyatelnostiID, 0.1), textAlign: "left", fontWeight: "bold", padding: "0px 5px", display: "flex" }}>
                                                    <div style={{ flex: "0 0 auto" }}>{`${item.vidDeyatelnosti?.nazvanie}`}</div>
                                                </div>),
                                                children: (<div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                                    {JSXMap(items?.filter(e => e.vidDeyatelnostiID == item?.vidDeyatelnostiID),
                                                        (dance, didx) => (<div key={didx} className='bg bg-fwhite pointer'
                                                            style={{
                                                                display: "flex",
                                                                gap: "5px",
                                                                textAlign: "left",
                                                                padding: "0 5px",
                                                                marginLeft: "5px"
                                                            }}>
                                                            <div style={{ flex: "1 1 auto" }}>
                                                                <div style={{ fontWeight: "bold" }}>
                                                                    <div>{dance?.tanets?.nazvanie}</div>
                                                                    {(dance?.tanets?.nazvanie !== dance?.tanets?.opisanie) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>{dance?.tanets?.opisanie}</div>}
                                                                </div>
                                                                <div style={{ display: "flex", gap: "5px", fontSize: "12px", fontWeight: "lighter" }}>
                                                                    {dance?.nachalo && <div>
                                                                        <span>с</span>
                                                                        <span style={{ marginLeft: "3px" }}>{dayjs(dance?.nachalo).format("YYYY")}</span>
                                                                        <span style={{ marginLeft: "1px" }}>г.</span>
                                                                    </div>}
                                                                    {dance?.okonchanie && <div>
                                                                        <span>до</span>
                                                                        <span style={{ marginLeft: "3px" }}>{dayjs(dance?.okonchanie).format("YYYY")}</span>
                                                                        <span style={{ marginLeft: "1px" }}>г.</span>
                                                                    </div>}
                                                                    {(dance?.nachalo && !dance?.okonchanie) && <div>
                                                                        <span>по настоящее время</span>
                                                                    </div>}
                                                                    <div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {(modelActions(dance, idx)?.length) && <div style={{ flex: "0 0 25px" }}>
                                                                <DropdownAction
                                                                    style={{ padding: "0" }}
                                                                    button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                                        <i className="fa fa-ellipsis-h"></i>
                                                                    </div>)}
                                                                    items={modelActions(dance, idx)?.map((e, idx) => ({
                                                                        key: e.key || idx,
                                                                        auth: auth,
                                                                        mode: "MenuItem",
                                                                        object: dance,
                                                                        collection: collection,
                                                                        setCollection: setCollection,
                                                                        ...e
                                                                    }))} />
                                                            </div>}
                                                        </div>))}
                                                </div>),
                                            })
                                        })}
                                    />
                                </div>
                            </Spin>
                        </div>)
                    }}
                    collectionActions={() => [
                        {
                            action: (values, unlock, close, { collection, setCollection }) => {
                                POST(auth, `/api/moitantsi/new`, values,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    },
                                    (err) => errorCatch(err, unlock));
                            },
                            form: Model,
                            meta: [
                                {
                                    "name": "VidDeyatelnosti",
                                    "type": "object",
                                    "label": "Вид деятельности",
                                    "relation": {
                                        "type": "many-one",
                                        "reference": {
                                            "object": "VidDeyatelnosti",
                                            "property": "ID"
                                        },
                                        displayString: (item) => {
                                            return item?.nazvanie
                                        },
                                        display: (item) => {
                                            return (
                                                item?.nazvanie
                                            )
                                        },
                                    },
                                    "validators": {
                                        "required": true,
                                    },
                                },
                                {
                                    "name": "Tanets",
                                    "type": "object",
                                    "label": "Танец",
                                    "relation": {
                                        "type": "many-one",
                                        "reference": {
                                            "object": "Tantsi",
                                            "property": "ID"
                                        },
                                        displayString: (item) => {
                                            return item?.nazvanie + ((item?.nazvanie !== item?.opisanie) ? " (" + item?.opisanie + ")" : "")
                                        },
                                        display: (item) => {
                                            return (
                                                <div>
                                                    <div>{item?.nazvanie}</div>
                                                    {(item?.nazvanie !== item?.opisanie) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>{item?.opisanie}</div>}
                                                </div>
                                            )
                                        },
                                    },
                                    "validators": {
                                        "required": true,
                                    },
                                },
                                {
                                    "name": "Nachalo",
                                    "type": "date",
                                    "label": "Начало",
                                    "validators": {
                                        "required": false,
                                    },
                                    inputProps: {
                                        needConfirm: true,
                                        picker: "year",
                                        format: "YYYY",
                                    }
                                },
                                {
                                    "name": "Okonchanie",
                                    "type": "date",
                                    "label": "Окончание",
                                    "validators": {
                                        "required": false,
                                    },
                                    inputProps: {
                                        needConfirm: true,
                                        picker: "year",
                                        format: "YYYY",
                                    }
                                },
                            ],
                            options: {
                                initialValues: {},
                            },
                            title: "Добавить танец",
                            modal: {
                                width: "400px",
                                title: "Новый танец",
                            }
                        }
                    ]}
                    modelActions={(item) => [{
                        auth: auth,
                        title: "Изменить",
                        modal: {
                            width: "400px",
                            title: "Изменить параметры танца",
                        },
                        object: item,
                        action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/moitantsi/update`, { ...item, ...values, ID: item.ID },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                close();
                            },
                            (err) => errorCatch(err, unlock)),
                        form: Model,
                        meta: [
                            // {
                            //     type: "func",
                            //     render: (auth, _item) => {
                            //         return (<div>
                            //             <div>{item?.tantsevalnayaDistsiplina?.nazvanie}</div>
                            //             <div><User item={item?.polzovatel} /></div>
                            //         </div>)
                            //     }
                            // },
                            {
                                "name": "VidDeyatelnosti",
                                "type": "object",
                                "label": "Вид деятельности",
                                "relation": {
                                    "type": "many-one",
                                    "reference": {
                                        "object": "VidDeyatelnosti",
                                        "property": "ID"
                                    },
                                    displayString: (item) => {
                                        return item?.nazvanie
                                    },
                                    display: (item) => {
                                        return (
                                            item?.nazvanie
                                        )
                                    },
                                },
                                "validators": {
                                    "required": true,
                                },
                                view: {
                                    disabled: true
                                }
                            },
                            {
                                "name": "Tanets",
                                "type": "object",
                                "label": "Танец",
                                "relation": {
                                    "type": "many-one",
                                    "reference": {
                                        "object": "Tantsi",
                                        "property": "ID"
                                    },
                                    displayString: (item) => {
                                        return item?.nazvanie + ((item?.nazvanie !== item?.opisanie) ? " (" + item?.opisanie + ")" : "")
                                    },
                                    display: (item) => {
                                        return (
                                            <div>
                                                <div>{item?.nazvanie}</div>
                                                {(item?.nazvanie !== item?.opisanie) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>{item?.opisanie}</div>}
                                            </div>
                                        )
                                    },
                                },
                                "validators": {
                                    "required": true,
                                },
                            },
                            {
                                "name": "Nachalo",
                                "type": "date",
                                "label": "Начало",
                                "validators": {
                                    "required": false,
                                },
                                inputProps: {
                                    needConfirm: true,
                                    picker: "year",
                                    format: "YYYY",
                                }
                            },
                            {
                                "name": "Okonchanie",
                                "type": "date",
                                "label": "Окончание",
                                "validators": {
                                    "required": false,
                                },
                                inputProps: {
                                    needConfirm: true,
                                    picker: "year",
                                    format: "YYYY",
                                }
                            },
                        ],
                    },
                    {
                        title: <span style={{ color: "red" }}>Удалить</span>,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            Modal.confirm({
                                title: `Вы уверены что хотите удалить танец?`,
                                icon: <ExclamationCircleOutlined />,
                                // content: <span>{item.opisanie}</span>,
                                okText: "Да",
                                okType: 'danger',
                                cancelText: "Нет",
                                onOk: () => {
                                    GET(auth, `/api/moitantsi/delete/${item.ID}`,
                                        () => {
                                            setCollection(deleteInArray(collection, item))
                                        }, errorCatch
                                    );
                                },
                            });
                        },
                    }
                    ]}
                />
            </div>}
            {
                JSXMap(Fields, (item, index) => {
                    const element = propertiesArray?.find(i => i.key == item.name);
                    const elementValues = _.head(element?.kollektsiiZnacheniiPoleiObekta)
                    const elementMD = propertiesArray?.find(i => i.key == (item.name + "_MD"));
                    const elementValuesMD = _.head(elementMD?.kollektsiiZnacheniiPoleiObekta)
                    return (
                        <div key={index} style={{ marginBottom: "6px" }}>
                            {(!!item?.array) && <ArrayField
                                item={item}
                                value={element?.kollektsiiZnacheniiPoleiObekta}
                                onChange={(val, onError, lock, unlock) => {

                                    if (lock) {
                                        lock()
                                    }
                                    if (!val && element) {
                                        GET(auth, `/api/dopolnitelniepolyaobekta/deletefield/${element?.ID}`,
                                            ({ data }) => {
                                                setPropertiesArray(o => deleteInArray(o, element))
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }, (err) => errorCatch(err, () => {
                                                onError(err);
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }))
                                        return
                                    }
                                    if (val && !val?.value && !val?.file && element) {
                                        GET(auth, `/api/dopolnitelniepolyaobekta/deletevalue/${val?.ID}`,
                                            ({ data }) => {
                                                setPropertiesArray(o => updateInArray(o, {
                                                    ...element,
                                                    kollektsiiZnacheniiPoleiObekta: deleteInArray(element.kollektsiiZnacheniiPoleiObekta, val)
                                                }))
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }, (err) => errorCatch(err, () => {
                                                onError(err);
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }))
                                        return
                                    }

                                    POSTFormData(auth, `/api/dopolnitelniepolyaobekta/set`, makeFormData({
                                        ...ContextObject,
                                        ...element,
                                        key: item.name,

                                        valueID: val?.ID,
                                        opisanie: val?.opisanie,
                                        file: val?.file,
                                        value: val?.value,
                                        aktualnoS: val?.aktualnoS,
                                        aktualnoDo: val?.aktualnoDo,

                                        kollektsiiZnacheniiPoleiObekta: undefined,

                                    }), ({ data }) => {
                                        setPropertiesArray(o => updateInArray(o, data))
                                        if (unlock) {
                                            unlock()
                                        }
                                    }, (err) => errorCatch(err, () => {
                                        onError(err);
                                        if (unlock) {
                                            unlock()
                                        }
                                    }))
                                }}
                            />}
                            {(!item?.array) && <div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div style={{ fontWeight: "bold", flex: "1 1 auto" }}>{item?.label}</div>
                                    <div style={{ flex: "0 0 30px", textAlign: "right" }}><i className="fa fa-pencil-square-o"></i></div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <Action
                                        auth={auth}
                                        action={(values, unlock, close, { collection, setCollection }) => {
                                            if (!values?.value && element) {
                                                GET(auth, `/api/dopolnitelniepolyaobekta/deletefield/${element?.ID}`,
                                                    ({ data }) => {
                                                        setPropertiesArray(o => deleteInArray(o, element))
                                                        if (unlock) {
                                                            unlock()
                                                        }
                                                        close();
                                                    }, (err) => errorCatch(err, () => {
                                                        if (unlock) {
                                                            unlock()
                                                        }
                                                    }))
                                                return
                                            }
                                            POSTFormData(auth, `/api/dopolnitelniepolyaobekta/set`, makeFormData({
                                                ...ContextObject,
                                                ...element,
                                                key: item.name,

                                                valueID: elementValues?.ID,
                                                active: values?.active,
                                                opisanie: values?.opisanie,
                                                value: values?.value,
                                                aktualnoS: (values?.aktualnoS) ? dayjs(values?.aktualnoS)?.format("YYYY-MM-DD") : undefined,
                                                aktualnoDo: (values?.aktualnoDo) ? dayjs(values?.aktualnoDo)?.format("YYYY-MM-DD") : undefined,

                                                kollektsiiZnacheniiPoleiObekta: undefined,

                                            }), ({ data }) => {
                                                setPropertiesArray(o => updateInArray(o, data))
                                                if (unlock) {
                                                    unlock()
                                                }
                                                close();
                                            }, (err) => errorCatch(err, () => {
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }))
                                        }}
                                        object={{
                                            value: (item?.array) ? element?.kollektsiiZnacheniiPoleiObekta : elementValues?.value,
                                            active: elementValues?.active,
                                            aktualnoDo: elementValues?.aktualnoDo,
                                            aktualnoS: elementValues?.aktualnoS,
                                            opisanie: elementValues?.opisanie,
                                            pole: elementValues?.pole,
                                            poleID: elementValues?.poleID,
                                        }}
                                        triggerOptions={{
                                            type: "primary"
                                        }}
                                        form={Model}
                                        meta={[
                                            {
                                                "name": "active",
                                                "type": "bool",
                                                "label": "Активно",
                                            },
                                            {
                                                ...item,
                                                name: "value",
                                                formItem: true,
                                                type: "func",
                                                render: EmojiField,
                                            },
                                            // {
                                            //     "name": "opisanie",
                                            //     "type": "text",
                                            //     "label": "Описание",
                                            //     "validators": {
                                            //         "required": false,
                                            //     }
                                            // },
                                            {
                                                "name": "aktualnoS",
                                                "type": "date",
                                                "label": "Актуально c",
                                                "validators": {
                                                    "required": false,
                                                }
                                            },
                                            {
                                                "name": "aktualnoDo",
                                                "type": "date",
                                                "label": "Актуально до",
                                                "validators": {
                                                    "required": false,
                                                }
                                            },
                                        ]}
                                        options={{
                                            initialValues: {

                                            },
                                        }}
                                        modal={{
                                            width: "900px",
                                            title: "Установка значения",
                                        }}

                                        mode="func"
                                        trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ padding: "5px", textAlign: "start", flex: "1 1 50%" }} >
                                            <div style={{ fontWeight: "bold", fontStyle: "italic", fontSize: "12px", }}>Текст для ВК</div>
                                            <div className="ext-properties" style={{ paddingTop: "5px", fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                                {elementValues?.value?.slice(0, 200)}
                                            </div>
                                        </div>)} />
                                    <Action
                                        auth={auth}
                                        action={(values, unlock, close, { collection, setCollection }) => {
                                            if (!values?.value && elementMD) {
                                                GET(auth, `/api/dopolnitelniepolyaobekta/deletefield/${elementMD?.ID}`,
                                                    ({ data }) => {
                                                        setPropertiesArray(o => deleteInArray(o, elementMD))
                                                        if (unlock) {
                                                            unlock()
                                                        }
                                                        close();
                                                    }, (err) => errorCatch(err, () => {
                                                        if (unlock) {
                                                            unlock()
                                                        }
                                                    }))
                                                return
                                            }
                                            POSTFormData(auth, `/api/dopolnitelniepolyaobekta/set`, makeFormData({
                                                ...ContextObject,
                                                ...elementMD,
                                                key: item.name + "_MD",

                                                valueID: elementValuesMD?.ID,
                                                active: values?.active,
                                                opisanie: values?.opisanie,
                                                value: values?.value,
                                                aktualnoS: (values?.aktualnoS) ? dayjs(values?.aktualnoS)?.format("YYYY-MM-DD") : undefined,
                                                aktualnoDo: (values?.aktualnoDo) ? dayjs(values?.aktualnoDo)?.format("YYYY-MM-DD") : undefined,

                                                kollektsiiZnacheniiPoleiObekta: undefined,

                                            }), ({ data }) => {
                                                setPropertiesArray(o => updateInArray(o, data))
                                                if (unlock) {
                                                    unlock()
                                                }
                                                close();
                                            }, (err) => errorCatch(err, () => {
                                                if (unlock) {
                                                    unlock()
                                                }
                                            }))
                                        }}
                                        object={{
                                            value: (item?.array) ? elementMD?.kollektsiiZnacheniiPoleiObekta : elementValuesMD?.value,
                                            active: elementValuesMD?.active,
                                            aktualnoDo: elementValuesMD?.aktualnoDo,
                                            aktualnoS: elementValuesMD?.aktualnoS,
                                            opisanie: elementValuesMD?.opisanie,
                                            pole: elementValuesMD?.pole,
                                            poleID: elementValuesMD?.poleID,
                                        }}
                                        triggerOptions={{
                                            type: "primary"
                                        }}
                                        form={Model}
                                        meta={[
                                            {
                                                "name": "active",
                                                "type": "bool",
                                                "label": "Активно",
                                            },
                                            {
                                                ...item,
                                                name: "value",
                                                formItem: true,
                                            },
                                            // {
                                            //     "name": "opisanie",
                                            //     "type": "text",
                                            //     "label": "Описание",
                                            //     "validators": {
                                            //         "required": false,
                                            //     }
                                            // },
                                            {
                                                "name": "aktualnoS",
                                                "type": "date",
                                                "label": "Актуально c",
                                                "validators": {
                                                    "required": false,
                                                }
                                            },
                                            {
                                                "name": "aktualnoDo",
                                                "type": "date",
                                                "label": "Актуально до",
                                                "validators": {
                                                    "required": false,
                                                }
                                            },
                                        ]}
                                        options={{
                                            initialValues: {

                                            },
                                        }}
                                        modal={{
                                            width: "900px",
                                            title: "Установка значения",
                                        }}

                                        mode="func"
                                        trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ padding: "5px", textAlign: "start", flex: "1 1 50%" }} >
                                            <div style={{ fontWeight: "bold", fontStyle: "italic", fontSize: "12px", }}>Текст страниц (Markdown)</div>
                                            <div className="ext-properties" style={{ paddingTop: "5px", fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                                <MDEditor.Markdown rehypePlugins={[[rehypeSanitize], [rehypeTruncate, { maxChars: 200 }]]} source={elementValuesMD?.value} />
                                            </div>
                                        </div>)} />
                                </div>
                            </div>}
                        </div>
                    )
                })
            }
        </div>
    );
}


export function ExtendedPropertiesAction(auth, subtitle, ContextObject, Fields, mode, dances) {
    return {
        // ...props,
        mode: mode,
        title: (<div>
            <div style={{}}>Установка дополнительных параметров</div>
        </div>),
        auth: auth,
        object: {},
        ContextObject: ContextObject,
        Fields: Fields,
        action: (values, unlock, close) => close(),
        form: ExtendedProperties,
        readonly: true,
        noAntForm: true,
        dances: dances,
        modal: {
            width: "800px",
            title: (<div>
                <div>Установка дополнительных параметров</div>
                <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>{subtitle}</div>
            </div>),
        }
    }
}